import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import { createLocalizedProxy, type CustomTranslations } from 'invite-sign/utils/translations';

import type QuestionnaireField from './questionnaire-field';

const TRANSLATABLE_ATTRIBUTE_MAPPING = {
  value: 'value',
} as const;
type TranslatableAttribute = keyof typeof TRANSLATABLE_ATTRIBUTE_MAPPING;

export default class QuestionnaireFieldOption extends Model {
  declare [Type]: 'questionnaire-field-option';

  @belongsTo('questionnaire-field', { async: false, inverse: 'questionnaireFieldOptions' })
  declare questionnaireField: QuestionnaireField;

  @attr() declare customTranslations: CustomTranslations<TranslatableAttribute>;
  @attr('boolean') declare isCorrect: boolean;
  @attr('number') declare position: number;
  @attr('string') declare value: string;

  forLocale(locale: string, defaultLocale: string): this {
    if (locale !== defaultLocale) {
      return createLocalizedProxy(this, TRANSLATABLE_ATTRIBUTE_MAPPING, locale);
    }
    return this;
  }
}
